import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Settings, Calendar, Shield } from 'lucide-react';

import ParametrageApp from './ParametrageApp';
import ClotureAnnee from './ClotureAnnee';
import AccessManagement from './AccessManagement';

const ConfigurationParent = () => {
  const [selectedMainTab, setSelectedMainTab] = useState('reglages');

  return (
    <div className="w-full p-4">
      <h1 className="text-3xl font-bold mb-6 text-[#246990]">Outils Administratifs</h1>

      {/* Navigation principale avec navigation stable */}
      <Tabs 
        defaultValue="reglages" 
        value={selectedMainTab} 
        onValueChange={setSelectedMainTab}
        className="w-full"
      >
        <TabsList className="grid grid-cols-3 mb-8 bg-[#246990]/10 w-full">
          <TabsTrigger 
            value="reglages" 
            className="flex items-center justify-center gap-2 data-[state=active]:bg-[#246990] data-[state=active]:text-white min-w-0"
          >
            <Settings size={16} />
            <span className="hidden md:inline whitespace-nowrap">Paramètres</span>
          </TabsTrigger>
          
          <TabsTrigger 
            value="access" 
            className="flex items-center justify-center gap-2 data-[state=active]:bg-[#246990] data-[state=active]:text-white min-w-0"
          >
            <Shield size={16} />
            <span className="hidden md:inline whitespace-nowrap">Accès & sécurité</span>
          </TabsTrigger>
          
          <TabsTrigger
            value="cloture"
            className="flex items-center justify-center gap-2 data-[state=active]:bg-[#246990] data-[state=active]:text-white min-w-0"
          >
            <Calendar size={16} />
            <span className="hidden md:inline whitespace-nowrap">Clôture annuelle</span>
          </TabsTrigger>
        </TabsList>

        {/* Contenu des onglets */}
        <TabsContent value="reglages">
          <ParametrageApp />
        </TabsContent>
        
        <TabsContent value="access">
          <AccessManagement />
        </TabsContent>
        
        <TabsContent value="cloture">
          <ClotureAnnee />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ConfigurationParent;